// Shared add-to-calendar builders (Google/Outlook deep links + .ics download).
// Used by the funnel confirmation and the /thanks page.

const stamp = (d) => d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z/, "Z");

export function gcalLink(startUtc, title, details, location = "") {
  const start = new Date(startUtc);
  const end = new Date(start.getTime() + 30 * 60000);
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${stamp(start)}/${stamp(end)}&details=${encodeURIComponent(details)}${location ? `&location=${encodeURIComponent(location)}` : ""}`;
}

export function outlookLink(startUtc, title, details, location = "") {
  const start = new Date(startUtc);
  const end = new Date(start.getTime() + 30 * 60000);
  return `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(title)}&startdt=${encodeURIComponent(start.toISOString())}&enddt=${encodeURIComponent(end.toISOString())}&body=${encodeURIComponent(details)}${location ? `&location=${encodeURIComponent(location)}` : ""}`;
}

export function downloadIcs(filename, startUtc, title, details, location = "") {
  const start = new Date(startUtc);
  const end = new Date(start.getTime() + 30 * 60000);
  const ics = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Slammed//Strategy Call//EN", "BEGIN:VEVENT",
    `UID:${Date.now()}@tryslammed.io`, `DTSTAMP:${stamp(new Date())}`, `DTSTART:${stamp(start)}`, `DTEND:${stamp(end)}`,
    `SUMMARY:${title}`, `DESCRIPTION:${details.replace(/[,;]/g, (c) => `\\${c}`)}`,
    location ? `LOCATION:${location}` : "", "END:VEVENT", "END:VCALENDAR"].filter(Boolean).join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
